// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"40ce441c","61":"40ce441c","236":"40ce441c","283":"40ce441c","321":"40ce441c","346":"c8b31a99","541":"40ce441c","638":"40ce441c","685":"40ce441c","769":"40ce441c","773":"40ce441c","886":"40ce441c","961":"40ce441c"}[chunkId] + ".chunk.css";
};